import { useQuery } from 'react-query'

import { getSectionsWithCategoryId } from '../../endpoints/howTo'

export const useGetSectionsWithCategoryId = (id: number | undefined) => {
    return useQuery(
        ['zendesk-sections-with-category-id', id],
        async () => await getSectionsWithCategoryId(id),
        {
            enabled: !!id,
            refetchOnWindowFocus: false
        }
    )
}
